import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicButton, BaasicFormControls } from "core/components";
import { Editor, EditorTools } from "@progress/kendo-react-editor";

const {
    Bold,
    Italic,
    Underline,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Undo,
    Redo,
    AddRowBefore,
    AddRowAfter,
    DeleteRow
} = EditorTools;

function UserEmailSignatureEditModalTemplate({ userEmailSignatureEditModalViewStore , t}) {
    const {
        form,
        emailSignature,
        modalParams
    } = userEmailSignatureEditModalViewStore;

    return (
        <section className='w--600--px'>
            <div className="modal__header">
                <h4 className='modal__header__title'>Change Email Signature</h4>
            </div>

            <div className="modal__body">
                <div className="form__group">
                    <Editor
                        resizable={true}
                        style={{ minHeight: 350 }}
                        tools={[
                            [Bold, Italic, Underline],
                            [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                            [AddRowBefore, AddRowAfter],
                            [DeleteRow],
                            [Undo, Redo]
                        ]}
                        contentStyle={{
                            minHeight: 292
                        }}
                        defaultContent={emailSignature}
                        onChange={(event) => { form.$("emailSignature").set(event.html); }}
                    />
                </div>
            </div>

            <div className='modal__footer is-right'>
                <BaasicFormControls
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    className='btn btn--med btn--primary'
                    label="Save"
                />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section> 
    )
}
 
UserEmailSignatureEditModalTemplate.propTypes = {
    userEmailSignatureEditModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(UserEmailSignatureEditModalTemplate);
